import { ref } from 'vue'
import { get } from '../../../utils/index'

export function useGetForm({ formModel, formUrl, formParam }) {
  const formData = ref({ ...formModel.value })

  const getFormData = async () => {
    if (formUrl.value) {
      const [resData] = await get(formUrl.value, formParam.value)
      formData.value = resData?.data ?? formData.value
    } else {
      formData.value = { ...formModel.value }
    }
  }
  return {
    formData,
    getFormData,
  }
}
